import { withInstall } from '@vuemap/vue-amap-util'
import Custom from './Custom.vue'

export const ElAmapLayerCustom = withInstall(Custom)
export default ElAmapLayerCustom
